const Colors = {
  // 5100ff
  // main: '#4250fb',
  main: "rgba(60,80,251,0.8)",
  pureMain: "rgba(60,80,251,1)",
  text: "#3A4554",
  lightMain: "rgba(60,80,251,0.3)",
  grey: "rgba(0, 0, 0, 0.54)",
  hardGrey: "rgba(155, 155, 155, 0.9)",
  green: "#7ED321",
  red: "rgba(255,0,47, 0.8)",
  mediumGreen: "#7DFFB3",
  pink: "#FC577A",
  lightGrey: "rgba(216,216,216,0.3)",
  veryLightGrey: "rgba(216,216,216,0.1)",
  mediumGrey: "#E6E6E6",
  orange: "#FFC107",
  gold: "#FCD462",
  yellow: "#FFD54F",
  blackGrey: "#4a4a4a",
  brandYellow: "#ebe55a",
  black: "#000",
  backGrey: "#FAFAFA",
  lightBlue: "#32C1FF",
  pollBlue: "#F3F5FA",
  pinkMetric: "rgba(252,87,122,0.8)",
  yellowMetric: "#FFC233",
  orangeMetric: "#FF9F40",
  blueMetric: "rgba(0,170,255,0.8)"
};

export default Colors;
